module.exports = __webpack_public_path__ + "static/media/BRAVES STADIUM B PIC 2.f564d9fe.jpg";